import { Dropdown, Button, Flex, Text } from '@bb/elements-web';
import { Icon } from 'components';
import React, { useMemo } from 'react';
import type { MenuProps } from '@bb/elements-web';

type NewAssetDropdownProps = {
  onNewAssetClick: (assetType: 'folder' | 'fileUpload' | 'videoLink') => void;
};

const NewAssetDropdown: React.FC<NewAssetDropdownProps> = ({
  onNewAssetClick,
}) => {
  const menuItems: MenuProps['items'] = useMemo(
    () => [
      {
        key: 'folder',
        label: (
          <Flex align="center" gap={8} data-cy="folder-menu-item">
            <Icon type="antdFolderOutlined" width={16} />
            Folder
          </Flex>
        ),
        onClick: () => onNewAssetClick('folder'),
      },
      {
        key: 'file-upload',
        label: (
          <Flex align="center" gap={8} data-cy="file-upload-menu-item">
            <Icon type="antdUploadOutlined" width={16} />
            File Upload
          </Flex>
        ),
        onClick: () => onNewAssetClick('fileUpload'),
      },
      {
        key: 'video-link',
        label: (
          <Flex align="center" gap={8} data-cy="video-link-menu-item">
            <Icon type="antdVideoCameraOutlined" width={16} />
            Video Link
          </Flex>
        ),
        onClick: () => onNewAssetClick('videoLink'),
      },
    ],
    [onNewAssetClick],
  );

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={['click']}
      placement="bottomLeft"
      dataCy="new-asset-dropdown"
    >
      <Button
        dataCy="new-asset-dropdown-button"
        type="primary"
        size="small"
        minWidth={50}
      >
        <Text size="middle" color="white" thickness="normal">
          + New
        </Text>
      </Button>
    </Dropdown>
  );
};

export default NewAssetDropdown;
